<script setup>
definePageMeta({
  layout: 'sign-in',
})

const clerkThemeStore = useClerkThemeStore()
</script>

<template>
  <SignIn
    :key="clerkThemeStore.key"
    :appearance="clerkThemeStore.appearance"
    sign-up-url="/sign-up"
    transferable
    with-sign-up
  />
</template>
